import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function MethodsFailSection() {
  const methods = [{
    title: '🍊 Vitamina C en el invierno',
    reason: 'Llega tarde. La microbiota ya está comprometida.'
  }, {
    title: '💊 Antibióticos cada vez que hay fiebre',
    reason: 'Apaga el incendio pero quema la casa por dentro.'
  }, {
    title: "🥛 Yakult o Actimel 'con probióticos'",
    reason: 'Tienen tan pocas cepas vivas y tanto azúcar que el beneficio es casi nulo.'
  }, {
    title: "🤞 Esperar que 'se le pase con la edad'",
    reason: 'Cada invierno sin reconstrucción activa es un invierno más débil.'
  }, {
    title: '💉 Solo la vacuna anual',
    reason: 'Protege contra cepas específicas, no construye inmunidad adaptativa.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-180">
      <div className="max-w-4xl mx-auto" data-id="element-181">
        <FadeIn data-id="element-182">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-green-deep text-center mb-12" data-id="element-183">
            ❌ POR QUÉ LOS MÉTODOS HABITUALES FALLAN
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-12" data-id="element-184">
          {methods.map((method, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-185">
              <div className="bg-white p-5 rounded-2xl shadow-sm border border-red-alert/10 flex items-start gap-4 h-full hover:-translate-y-1 transition-transform duration-300" data-id="element-186">
                <XCircle className="w-6 h-6 text-red-alert shrink-0 mt-1" data-id="element-187" />
                <div data-id="element-188">
                  <h3 className="font-bold text-text-main mb-2" data-id="element-189">
                    {method.title}
                  </h3>
                  <p className="text-text-main/80 text-sm md:text-base leading-relaxed" data-id="element-190">
                    {method.reason}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-191">
          <div className="text-center max-w-2xl mx-auto" data-id="element-192">
            <p className="font-bold text-lg md:text-xl text-red-alert mb-2" data-id="element-193">
              Ninguno de estos enfoques ataca la raíz.
            </p>
            <p className="text-text-main text-base md:text-lg" data-id="element-194">
              La raíz es la microbiota. Y la microbiota se construye con comida
              real — <strong data-id="element-195">desde la cocina.</strong>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}